export default {
    'zh_CN': {
        'property.green-area.id.label': '主键',
        'property.green-area.id.holder': '请输入主键',
        
        
        'property.green-area.id.required': '主键必填',
        'property.green-area.greenNo.label': '绿化区域编号',
        'property.green-area.greenNo.holder': '请输入绿化区域编号',
        'property.green-area.greenNo.max': '绿化区域编号最多50个字符',
        
        'property.green-area.greenNo.required': '绿化区域编号必填',
        'property.green-area.name.label': '名称',
        'property.green-area.name.holder': '请输入名称',
        'property.green-area.name.max': '名称最多60个字符',
        
        'property.green-area.name.required': '名称必填',
        'property.green-area.areaDescribe.label': '区域描述',
        'property.green-area.areaDescribe.holder': '请输入区域描述',
        'property.green-area.areaDescribe.max': '区域描述最多255个字符',
        
        'property.green-area.areaDescribe.required': '区域描述必填',
        'property.green-area.greenVegetation.label': '绿化植被描述',
        'property.green-area.greenVegetation.holder': '请输入绿化植被描述',
        'property.green-area.greenVegetation.max': '绿化植被描述最多255个字符',
        
        'property.green-area.greenVegetation.required': '绿化植被描述必填',
        'property.green-area.createTime.label': '创建时间',
        'property.green-area.createTime.holder': '请输入创建时间',
        'property.green-area.createTime.required': '创建时间必填',
        'property.green-area.updateTime.label': '修改时间',
        'property.green-area.updateTime.holder': '请输入修改时间',
        'property.green-area.updateTime.required': '修改时间必填',
        'property.green-area.isDelete.label': '是否删除',
        'property.green-area.isDelete.holder': '请输入是否删除',
        
        
        'property.green-area.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.green-area.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.green-area.id.label': '主键',
        'property.green-area.id.holder': '請輸入主键',
        
        
        'property.green-area.id.required': '主键必填',
        'property.green-area.greenNo.label': '绿化区域编号',
        'property.green-area.greenNo.holder': '請輸入绿化区域编号',
        
        
        'property.green-area.greenNo.required': '绿化区域编号必填',
        'property.green-area.name.label': '名称',
        'property.green-area.name.holder': '請輸入名称',
        
        
        'property.green-area.name.required': '名称必填',
        'property.green-area.areaDescribe.label': '区域描述',
        'property.green-area.areaDescribe.holder': '請輸入区域描述',
        
        
        'property.green-area.areaDescribe.required': '区域描述必填',
        'property.green-area.greenVegetation.label': '绿化植被描述',
        'property.green-area.greenVegetation.holder': '請輸入绿化植被描述',
        
        
        'property.green-area.greenVegetation.required': '绿化植被描述必填',
        'property.green-area.createTime.label': '创建时间',
        'property.green-area.createTime.holder': '請輸入创建时间',
        
        
        'property.green-area.createTime.required': '创建时间必填',
        'property.green-area.updateTime.label': '修改时间',
        'property.green-area.updateTime.holder': '請輸入修改时间',
        
        
        'property.green-area.updateTime.required': '修改时间必填',
        'property.green-area.isDelete.label': '是否删除',
        'property.green-area.isDelete.holder': '請輸入是否删除',
        
        
        'property.green-area.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.green-area.id.label': 'id',
        'property.green-area.id.holder': 'Enter id',
        'property.green-area.id.max': 'id max length: 主键',
        
        
        'property.green-area.id.required': 'id required',
        'property.green-area.greenNo.label': 'greenNo',
        'property.green-area.greenNo.holder': 'Enter greenNo',
        'property.green-area.greenNo.max': 'greenNo max length: 绿化区域编号',
        
        
        'property.green-area.greenNo.required': 'greenNo required',
        'property.green-area.name.label': 'name',
        'property.green-area.name.holder': 'Enter name',
        'property.green-area.name.max': 'name max length: 名称',
        
        
        'property.green-area.name.required': 'name required',
        'property.green-area.areaDescribe.label': 'areaDescribe',
        'property.green-area.areaDescribe.holder': 'Enter areaDescribe',
        'property.green-area.areaDescribe.max': 'areaDescribe max length: 区域描述',
        
        
        'property.green-area.areaDescribe.required': 'areaDescribe required',
        'property.green-area.greenVegetation.label': 'greenVegetation',
        'property.green-area.greenVegetation.holder': 'Enter greenVegetation',
        'property.green-area.greenVegetation.max': 'greenVegetation max length: 绿化植被描述',
        
        
        'property.green-area.greenVegetation.required': 'greenVegetation required',
        'property.green-area.createTime.label': 'createTime',
        'property.green-area.createTime.holder': 'Enter createTime',
        'property.green-area.createTime.max': 'createTime max length: 创建时间',
        
        
        'property.green-area.createTime.required': 'createTime required',
        'property.green-area.updateTime.label': 'updateTime',
        'property.green-area.updateTime.holder': 'Enter updateTime',
        'property.green-area.updateTime.max': 'updateTime max length: 修改时间',
        
        
        'property.green-area.updateTime.required': 'updateTime required',
        'property.green-area.isDelete.label': 'isDelete',
        'property.green-area.isDelete.holder': 'Enter isDelete',
        'property.green-area.isDelete.max': 'isDelete max length: 是否删除',
        
        
        'property.green-area.isDelete.required': 'isDelete required'
    }
}
